import { debounce } from './common/debounce';
export class ScrollDetector {
    constructor(win = window, doc = win.document) {
        this.win = win;
        this.doc = doc;
        this.lastPosition = 0;
        this.delta = 50;
    }
    activate() {
        this.updateLastPosition();
        this.onScroll();
        this.win.addEventListener('scroll', debounce(() => this.onScroll()), false);
    }
    onScroll() {
        if (this.isAtTheTop()) {
            this.doc.body.classList.add('scrolled-top');
            this.doc.body.classList.remove('scrolled-non-top');
        }
        else {
            this.doc.body.classList.remove('scrolled-top');
            this.doc.body.classList.add('scrolled-non-top');
        }
        if (this.isAtTheBottom()) {
            this.doc.body.classList.add('scrolled-bottom');
            this.doc.body.classList.remove('scrolled-non-bottom');
        }
        else {
            this.doc.body.classList.remove('scrolled-bottom');
            this.doc.body.classList.add('scrolled-non-bottom');
        }
        const currentPosition = this.win.scrollY;
        if (currentPosition < this.lastPosition + this.delta
            && currentPosition > this.lastPosition - this.delta) {
            return;
        }
        if (currentPosition > this.lastPosition) {
            this.doc.body.classList.remove('scrolled-up');
            this.doc.body.classList.add('scrolled-down');
        }
        else {
            this.doc.body.classList.add('scrolled-up');
            this.doc.body.classList.remove('scrolled-down');
        }
        this.updateLastPosition();
    }
    updateLastPosition() {
        this.lastPosition = this.win.scrollY;
    }
    isAtTheTop() {
        return this.win.scrollY <= 0;
    }
    isAtTheBottom() {
        return (window.innerHeight + window.scrollY) >= this.doc.body.offsetHeight;
    }
}
